import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as InvoiceChargeNumberActions from './invoice-charge-number.actions';
import { InvoiceChargeNumber } from './invoice-charge-number.model';

export const invoiceChargeNumbersFeatureKey = 'invoiceChargeNumbers';

export interface State extends EntityState<InvoiceChargeNumber> {
    // additional entities state properties
}

export const adapter: EntityAdapter<InvoiceChargeNumber> =
    createEntityAdapter<InvoiceChargeNumber>();

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const invoiceChargeNumberReducer = createReducer(
    initialState,
    on(InvoiceChargeNumberActions.addInvoiceChargeNumber, (state, action) =>
        adapter.addOne(action.invoiceChargeNumber, state)
    ),
    on(InvoiceChargeNumberActions.upsertInvoiceChargeNumber, (state, action) =>
        adapter.upsertOne(action.invoiceChargeNumber, state)
    ),
    on(InvoiceChargeNumberActions.addInvoiceChargeNumbers, (state, action) =>
        adapter.addMany(action.invoiceChargeNumbers, state)
    ),
    on(InvoiceChargeNumberActions.upsertInvoiceChargeNumbers, (state, action) =>
        adapter.upsertMany(action.invoiceChargeNumbers, state)
    ),
    on(InvoiceChargeNumberActions.updateInvoiceChargeNumber, (state, action) =>
        adapter.updateOne(action.invoiceChargeNumber, state)
    ),
    on(InvoiceChargeNumberActions.updateInvoiceChargeNumbers, (state, action) =>
        adapter.updateMany(action.invoiceChargeNumbers, state)
    ),
    on(InvoiceChargeNumberActions.deleteInvoiceChargeNumber, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(InvoiceChargeNumberActions.deleteInvoiceChargeNumbers, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(InvoiceChargeNumberActions.loadInvoiceChargeNumbers, (state, action) =>
        adapter.setAll(action.invoiceChargeNumbers, state)
    ),
    on(InvoiceChargeNumberActions.clearInvoiceChargeNumbers, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return invoiceChargeNumberReducer(state, action);
}
